module.exports = __webpack_public_path__ + "img/zhong.d2f55a35.svg";